import React, { useContext, useEffect, useState, createRef, useCallback } from 'react'
import { AboutJob } from '../../components/AboutJob'
import { Disclosure } from '../../components/Disclosure'
import { JobDetailsShow } from '../../components/JobDetailsShow'
import { Pagination } from '../../components/Pagination'
import { Tag } from '../../components/Tag'
import { ADVERTISER_CATEGORIES, DISCLAIMER, EMAIL_US, MICRO_LOCATION_SEARCH, RECOMMENDATIONS_ENDPOINT } from '../../constants/all'
import {
  fetchNextJobDetails,
  findPostOrFutureTime,
  getMethod,
  jobDetailsTitle,
  multipleGetCalls,
  rediretionHandler,
  seekersAnalayticOptions
} from '../../utils/functions'
import { CircularSpinner } from '../../components/CircularSpinner'
import classNames from 'classnames'
import useTranslation from '../../hooks/useTranslation'
import ImageWithBasePath from '../../components/ImageWithBasePath'
import domtoimage from 'dom-to-image'
import Cookies from 'universal-cookie'
import { FooterModelForApplyJob } from '../../components/FooterModelForApplyJob'
import { UnderLinedButton } from '../../components/UnderlinedButton'
import { Breadcrumbs } from '../../components/Breadcrumbs'
import Head from 'next/head'
import { Media } from '../../commonComponents/Media'
import { JobCardFooter } from '../../components/JobCardFooter'
import { trackEvent } from '../../analytics'
import { seekersPageScripts } from '../_app'
import { clog } from '../../utils/functions'
import { useRouter } from 'next/router'
import SeoJsonLd from '../../commonComponents/SeoJsonLd.js'
import { BreadCrumbs } from '../../commonComponents/BreadCrumbs.js'
import { SharedContext } from '../../context/SharedContext.js'
import { SeekerContext } from '../../context/SeekerContext.js'

const DisclosuresDiv = ({ jobDetails, translation }) => {
  const isFeePresent = jobDetails?.translated_content?.fee_details?.['V3']?.length > 0

  return (
    <div>
      <Disclosure
        id="job_details_disclosure"
        title={translation?.disclosureTitle?.jobDetails}
        isDefaultOpen={true}
        isSelected={true}
      >
        <JobDetailsShow
          {...{
            primary_details: jobDetails?.translated_content?.primary_details,
            contentV3: jobDetails?.translated_content?.contentV3,
            Openings: jobDetails?.openings_count,
            jobHours: jobDetails?.job_hours
          }}
        />
      </Disclosure>
      <Disclosure
        id="job_fee_disclosure"
        title={
          isFeePresent
            ? translation?.disclosureTitle?.feesRequired
            : translation?.disclosureTitle?.noFeeIsRequired
        }
        titleImagePath={'info'}
        isSelected={true}
      >
        {isFeePresent && (
          <div className="py-[12px] font-noto-sans">
            <div className="space-y-[4px]">
              <div className="text-[11px] font-normal leading-[14.98px] text-[#66676B]">
                {translation?.whyIsItNeeded}?
              </div>
              <div className="text-base font-normal leading-[19.67px] text-[#000000]">
                {jobDetails?.translated_content?.fee_details?.['V3']?.[1]?.field_value || '-'}
              </div>
            </div>
            <div className="mt-[12px] flex w-[100%] pb-[16px]">
              {(jobDetails?.translated_content?.fee_details?.['V3'] || [])?.map((item, index) => {
                if (item.field_key == 'fee_reason') return null
                return (
                  <div
                    key={index}
                    className={classNames(
                      'spaxe-y-[4px] flex w-[50%] flex-col',
                      index == 0 && 'border-[0px] border-r-xs border-solid border-xLigthGray',
                      item.field_key == 'fee_collected_at' && 'pl-[11px]'
                    )}
                  >
                    <div className="text-[11px] font-normal leading-[14.98px] text-[#66676B]">
                      {item?.field_name}
                    </div>
                    <div className="text-base font-normal leading-[19.07px] text-[#000000]">
                      {item?.field_value || '-'}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Disclosure>
      <Disclosure id="Additional_job_details_disclosure" title={'Additional information'}>
        <div className="py-[12px] text-base font-normal leading-19 text-[#66676B]">
          {jobDetails?.translated_content?.other_details?.length > 0
            ? jobDetails?.translated_content?.other_details
            : '-'}
        </div>
      </Disclosure>
      <Disclosure id="job_disclaimer_disclosure" title={'Disclaimer'}>
        <div className="py-[12px] text-base font-normal leading-[19.07px] text-[#66676B]">
          {DISCLAIMER}
          <div className="mt-[2px] flex">
            {translation?.emailUsOn}:{' '}
            <UnderLinedButton
              title={EMAIL_US}
              onClick={() => window.open('mailto:' + EMAIL_US)}
              className="ml-[2px] font-normal"
            />
          </div>
        </div>
      </Disclosure>
    </div>
  )
}

const JobDetails = ({ jobDetails = {}, recommendationDetails = {}, query, cityLocations, jobCategories }) => {
  const {location:cityLocation, category:selectedCategory} = query;
  const {
    language,
    loginDetails,
    setShowToast,
    setUtmParams,
    utmParams
  } = useContext(SharedContext);
  
  const {
    setLogInOpen,
    isJobProfileCreated
  } = useContext(SeekerContext);

  const [pagination, setPagination] = useState({ pageNumber: 1, hasMore: true })
  const [recommendations, setRecommendations] = useState({})
  const translation = useTranslation()
  const ref = createRef(null)
  const [hydrated, setHydrated] = useState(false)
  const [showIsAppiledModel, setIsShowAppiledModel] = useState(false)
  const [isApplied, setIsApplied] = useState(false)
  const [loading, setLoading] = useState(false)
  const description =
    'Find the best staff for your vacancies with Lokal. Browse and filter candidates from your district, and get in touch within 24hrs. First job ad is for free, hire now!'

  const router = useRouter()

  const createdataList = jobDetails?.creatives
  const imageUrl =
    createdataList?.[createdataList.length - 1]?.file || createdataList?.[0].file || ''

  useEffect(() => {
    setIsApplied(jobDetails?.is_applied || false)
  }, [])

  const getImage = useCallback(async () => {
    if (ref.current === null) {
      return
    }
    return await domtoimage
      .toPng(ref.current, { cacheBust: true, backgroundColor: '#FFFFFF' })
      .catch((err) => {
        clog(err)
      })
  }, [ref])

  useEffect(() => {
    const selectedBody = JSON.parse(localStorage.getItem("body"))

    if(cityLocation && cityLocation !== "undefined"){
      const matchedLocation = cityLocations?.find(city => city?.title.toLowerCase() === cityLocation.toLowerCase());
      if(matchedLocation){
        localStorage.setItem("location",JSON.stringify(matchedLocation))
      }
    }

    if(cityLocation && selectedCategory){
      const matchedCategory = jobCategories?.find(category => (category?.title).replace(/ /g, '')
      ?.replace(/\//g, '-and-')
      ?.replace('&', '-and-')?.toLowerCase() === selectedCategory.toLowerCase())
      if(matchedCategory){
        localStorage.setItem("body",JSON.stringify({...selectedBody, selectedOptions: { ...selectedBody?.selectedOptions, ...{37:[matchedCategory]} }}))
      }
    }
   
  }, [])

  useEffect(() => {
    setHydrated(true)
    trackEvent({
      name: 'seeker_details_page_viewed',
      searchParams: {
        ...(router?.query || {})
      },
      options: {
        ...seekersAnalayticOptions(
          window,
          loginDetails,
          location,
          'impression',
          'seeker_details_page'
        ),
        Classified_id: jobDetails?.id
      },
      isSeeker: true
    })
    setUtmParams(router?.query || {})
    let jobs = recommendationDetails?.results?.filter(
      (item) => item?.job_role && item?.translated_content?.title
    )
    if (jobs?.length <= 2) setPagination((prv) => ({ ...prv, hasMore: false }))
    if (jobs?.length) {
      setRecommendations([...jobs])
     }
  }, [])
  if (!hydrated) {
    // Returns null on first render, so the client and server match
    return seekersPageScripts()
  }

  const jobDetailsSchema = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: jobDetailsTitle(jobDetails),
    description: `${(<p>{description}</p>)}`,
    datePosted: jobDetails?.updated_on,
    validThrough: jobDetails?.expire_on,
    employmentType: jobDetails?.job_hours,
    jobLocationType: jobDetails?.primary_details?.Job_type == 'Work From Home' ? 'TELECOMMUTE' : '',
    hiringOrganization: {
      '@type': 'Organization',
      name: jobDetails?.company_name,
      logo: jobDetails.creatives?.[0]['file']
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: jobDetails?.job_location_slug,
        addressCountry: 'IN'
      }
    },
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: 'INR',
      value: {
        '@type': 'QuantitativeValue',
        value: jobDetails?.primary_details?.Salary,
        unitText: 'Month'
      }
    }
  }

  return (
    <>
      <Head>
        <title>{jobDetailsTitle(jobDetails)}</title>
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="og:title" content={jobDetailsTitle(jobDetails)} />
        <meta property="og:image" content={jobDetails.creatives?.[0]['file']} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="315" />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:title" content={jobDetailsTitle(jobDetails)} />
        <meta property="twitter:image" content={jobDetails.creatives?.[0]['file']} />
        <meta property="twitter:image:width" content="600" />
        <meta property="twitter:image:height" content="315" />
        <script type="application/ld+json">{JSON.stringify(jobDetailsSchema)}</script>
      </Head>
      {seekersPageScripts()}
      <div className="sticky top-[44px] z-20 bg-white px-[12px] pt-[20px] pb-[16px] sm:top-[80px] sm:px-[40px] sm:pb-[24px] md:px-[80px]">
        <BreadCrumbs page = "jobsDetails" jobDetails = {jobDetails} />
      </div>
      <div id="job_details" className="flex h-full w-full flex-col pb-[100px]">
        <div id="details" className="px-[12px] font-noto-sans sm:px-[40px] md:px-[80px]" ref={ref}>
          <div id="job_main_details" className="flex items-center space-x-[10px]">
            <ImageWithBasePath
              id="job_logo"
              src={imageUrl}
              isurl={'true'}
              width={50}
              height={50}
              className="rounded-xs"
              alt="Job Logo"
            />
            <div className="flex flex-1 flex-col">
              <div
                id="job_company_name"
                className="text-base font-normal leading-[19.07px] text-[#000000]"
              >
                {jobDetails?.translated_content?.company_name}
              </div>
              <div
                id="posted_time"
                className="flex space-x-[5px] text-[11px] font-normal leading-[14.98px] text-[#97989B]"
              >
                {`${translation?.posted} ${findPostOrFutureTime(jobDetails?.created_on)} ${
                  translation?.ago
                } • ${jobDetails?.views} ${translation?.views}`}
              </div>
            </div>
          </div>

          <div className="mt-lg mb-exlg space-y-[8px]">
            <h1 id="job_role" className="text-xl font-bold leading-[28px] text-[#3B3A40]">
              {jobDetails?.job_role}
            </h1>
            <h2 id="job_title" className="text-base font-normal text-[#66676B]">
              {jobDetails?.translated_content?.title}
            </h2>
            <div id="job_tags" className="scrollbarHidden flex space-x-[4px] overflow-x-scroll">
              {(jobDetails?.translated_content?.job_tags || [])?.map((tag, index) => {
                return (
                  <div key={index}>
                    <Tag
                      {...{
                        id: `job_${index}`,
                        title: tag?.value,
                        style: { backgroundColor: tag?.bg_color, color: tag?.text_color }
                      }}
                    />
                  </div>
                )
              })}
            </div>
          </div>
          <Media greaterThan="sm">
            <div className="flex items-center justify-end pb-[16px]">
              <JobCardFooter
                {...{
                  jobDetails,
                  isApplied,

                  setLoading,
                  setIsApplied,

                  getImage
                }}
              />
            </div>
          </Media>
          <DisclosuresDiv {...{ jobDetails, translation }} />
        </div>
        {recommendations?.length > 0 ? (
          <div
            id="similar_jobs"
            className="bg-[#404040] bg-opacity-[0.03] px-[12px] pt-[36px] font-noto-sans sm:px-[40px] md:px-[80px]"
          >
            <div id="similar_job_title" className="text-lg font-bold leading-[28px] text-[#3B3A40]">
              {translation?.similarJobs}
            </div>

            <Pagination
              listLength={recommendations?.length}
              next={() =>
                fetchNextJobDetails({
                  jobDetails,
                  pagination,
                  setPagination,
                  setRecommendations,
                  language
                })
              }
              hasMore={pagination.hasMore}
              loader={<CircularSpinner />}
              className="overflow-hidden"
            >
              <div id="similar_job_container" className="my-[16px] space-y-[12px]">
                {recommendations?.map((item, index) => {
                  return <AboutJob jobDetails={item} key={index} />
                })}
              </div>
            </Pagination>
          </div>
        ) : (
          <div
            id="no_similar_jobs"
            className="my-lg flex justify-center font-noto-sans text-base font-normal leading-[14.98px] text-[#97989B]"
          >
            {translation?.noSimilarJobs}{' '}
          </div>
        )}
        <Media at="sm">
          <div
            id="job_footer"
            className="fixed bottom-0 z-10 flex w-full items-center border-[0px] border-t-xs border-solid border-[#E5E5E6] bg-white py-16 px-[12px]"
          >
            <JobCardFooter
              {...{
                jobDetails,
                isApplied,
                setLoading,
                setIsApplied,
                getImage
              }}
            />
          </div>
        </Media>
      </div>

      <FooterModelForApplyJob
        {...{
          setIsShowAppiledModel,
          rediretionHandler: (props) => {
            rediretionHandler({
              ...props,
              link: jobDetails?.custom_link,
              loginDetails,
              setLogInOpen,
              isJobProfileCreated,
              setLoading,
              setIsApplied,
              jobDetails,
              setShowToast,
              utmParams,
              window,
              location,
              id: jobDetails?.id,
              source: 'details page'
            })
          },
          showIsAppiledModel,
          isApplied,
          jobDetails,
          loading
        }}
      />
    </>
  )
}

export default JobDetails

export const getServerSideProps = async (context) => {
  const { jobId } = context?.query
  const cookies = new Cookies(context.req.headers.cookie)
  const language = cookies.get('language')
  const location = cookies.get('location')
  const jobDetails = await getMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + `/classifieds/classifieds/${jobId}/retrieve_v2/`,
    headers: { 'Accept-Language': language, source: 'jobs_web' }
  })

  const recommendationParams = {
    location_id: location?.id,
    page: 1,
    classified_id: jobDetails?.id
  }
  const recommendationDetails = await getMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + RECOMMENDATIONS_ENDPOINT,
    params: recommendationParams,
    headers: { 'Accept-Language': language, source: 'jobs_web' }
  })

  const apiDetails = [
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + MICRO_LOCATION_SEARCH,
      params: { q: context?.query?.location },
      headers: {'App-Type': 'web', 'Accept-Language':'en'}
    },
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + ADVERTISER_CATEGORIES,
      header: { 'Accept-Language': language },
      isTokenPresent: false
    }
  ]

  const res = await multipleGetCalls(apiDetails)

  return {
    props: {
      jobDetails,
      recommendationDetails,
      query: context?.query,
      cityLocations: res?.[0]?.results,
      jobCategories: res?.[1]
    }
  }
}
